import React, { useRef, useState, useCallback } from "react";

// Horizontally resizable panel with a drag handle on one edge. Width persists to localStorage.
export function ResizablePanel({ side = "right", storageKey, defaultWidth = 320, min = 220, max = 680, className = "", children, ...rest }) {
    const [width, setWidth] = useState(() => {
        const s = storageKey && Number(localStorage.getItem(storageKey));
        return s && s >= min && s <= max ? s : defaultWidth;
    });
    const start = useRef({ x: 0, w: 0 });

    const onMove = useCallback((e) => {
        const delta = e.clientX - start.current.x;
        let w = side === "right" ? start.current.w + delta : start.current.w - delta;
        w = Math.max(min, Math.min(max, w));
        setWidth(w);
    }, [side, min, max]);

    const onUp = useCallback(() => {
        document.removeEventListener("mousemove", onMove);
        document.removeEventListener("mouseup", onUp);
        document.body.style.userSelect = "";
        document.body.style.cursor = "";
        setWidth((w) => { if (storageKey) localStorage.setItem(storageKey, String(w)); return w; });
    }, [onMove, storageKey]);

    const onDown = (e) => {
        start.current = { x: e.clientX, w: width };
        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onUp);
        document.body.style.userSelect = "none";
        document.body.style.cursor = "col-resize";
    };

    return (
        <div style={{ width }} className={`relative shrink-0 h-full ${className}`} {...rest}>
            <div className="h-full overflow-auto">{children}</div>
            <div
                data-testid={`resize-handle-${side}`}
                onMouseDown={onDown}
                className={`absolute top-0 bottom-0 ${side === "right" ? "-right-0.5" : "-left-0.5"} w-1.5 cursor-col-resize z-20 group`}>
                <div className="w-0.5 h-full mx-auto bg-transparent group-hover:bg-brand/50 transition-colors" />
            </div>
        </div>
    );
}
